export const slideInOut = (index?: number) => ({
  initial: { x: "calc(50vw - 0%)", opacity: 0 },
  animate: { x: "calc(50vw - 50%)", opacity: 1 },
  exit: { x: "calc(50vw - 100%)", opacity: 0, transition: { delay: 0 } },
  transition: { ease: "easeOut", duration: 0.3, delay: 0.1 + (index || 0) * 0.07 }
})

export const fadeIn = () => ({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 1 }
})
